<template>


  <CContainer>
    <CRow>
      <CCol  class="text-left">
      <br>
      <CButton color="info" @click="scan">Scan</CButton>
      <alertmodal></alertmodal>
      </CCol>
    </CRow>
    <CRow v-if="camera_hide === false">
      <CCol>

      </CCol>
    </CRow>
    <CRow v-if="camera_hide === false">
      <CCol>
        <br>
        <div style="width: 100%: height: 50%"><qrcode-stream @decode="onDecode" @init="onInit"/></div>
        <p class="error">{{ error }}</p>
        <!-- <p class="decode-result">Last result: <b>{{ result }}</b></p> -->
        
      </CCol>
    </CRow>
    <CRow v-if="result_hide === false">
      <CCol>
        <br>
            <row class="mt-3">
              <h4 class="ml-5 "> Orders Detail </h4> 
            </row>
            <br>
            <row >
              <p class="ml-5"> Booking ID: {{ data.booking_id }}</p>
              <p class="ml-5"> Name: {{ data.name }}</p>
              <p class="ml-5"> Address: {{ data.address }} </p>
              <p class="ml-5"> Email: {{ data.email }} </p>
              <p class="ml-5"> Mobile Phone: {{ data.mobile_phone }} </p>
              <p class="ml-5"> Payment Status: {{ data.payment_status }} </p>
            </row>
            <br>
            <row >
              <label class="ml-5 mt-3 text-info" > Ticket Details </label>
            </row>
            <row class="mt-3 ml-3">
              <table>
                  <thead>
                  <tr>
                      <th>Name</th>
                      <th>Quantity</th>
                      <th>Attend</th>
                  </tr>
                  </thead>
                  <tr v-for="(arr, index) in form.att" :key="index">
                      <td>
                        {{ arr.type.name }}
                      </td>
                      <td>
                          {{ arr.qty }} Ticket
                      </td>
                      <td>
                          <CInput
                            type="number"
                            label=""
                            v-model="arr.attend"
                            min="0"    
                            :invalid-feedback="messageInvalidFeedback(arr.qty)"  
                            :is-valid="validatorTicket(arr.attend,arr.qty)"              
                          />
                      </td>
                  </tr>
              </table>
            </row>
            <CRow v-if="!loading_submit" class="justify-content-center">
              <CButton style="width:200px" color="success" block v-on:click.prevent="submit()" type="submit" >Submit</CButton>
            </CRow>
            <CRow v-else class="justify-content-center">
              <b-spinner variant="primary" label="Spinning"><br></b-spinner>
            </CRow>
      </CCol>
    </CRow>
    <!-- <pre>{{ $data | json }}</pre> -->
  </CContainer>

</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

import event from '@/services/event'
import EventBus from '@/eventBus';
import alertmodal from '@/views/alert/modal.vue';

export default {

  components: { QrcodeStream, alertmodal },

  data () {
    return {
      data:[],
      id: '',
      form:{
        att:[],
      },
      result: '',
      error: '',
      camera_hide: false,
      result_hide: true,
      message: '',
      message_hide: true,
      loading_submit: false,
    }
  },

  methods: {
    onDecode (result) {
      this.result = result

        event.getEventbyID_getorderdetail_bycode(this.$route.query.id,result)
        .then(res => {
            this.data = res.data; 
            this.id = res.data.id;
            this.form.att = res.data.order_details
            this.camera_hide = true;
            this.result_hide = false;
        }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
            this.camera_hide = true;
        })

    },

    async onInit (promise) {
      try {
        await promise
      } catch (error) {
        if (error.name === 'NotAllowedError') {
          this.error = "ERROR: you need to grant camera access permisson"
        } else if (error.name === 'NotFoundError') {
          this.error = "ERROR: no camera on this device"
        } else if (error.name === 'NotSupportedError') {
          this.error = "ERROR: secure context required (HTTPS, localhost)"
        } else if (error.name === 'NotReadableError') {
          this.error = "ERROR: is the camera already in use?"
        } else if (error.name === 'OverconstrainedError') {
          this.error = "ERROR: installed cameras are not suitable"
        } else if (error.name === 'StreamApiNotSupportedError') {
          this.error = "ERROR: Stream API is not supported in this browser"
        }
      }
    },

    scan: function () {
      this.camera_hide = false;
      this.result_hide = true;
    },

    validatorTicket: function(val,max) {
      if(val >= 0 && val <= max){
        return null;
      }else{
        return false;
      }
      //return val ? (val >= 0 && val <= max) : false
    },
    messageInvalidFeedback: function(max) {
      return "Maksimal " + max + " tiket"
    },
    submit(){
      //alert('asd');
      this.loading_submit = true
      event.createEventAttendance(this.id, this.form)
      .then(res => {
          console.log(res.meesage)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          this.camera_hide = false;
          this.result_hide = true;
      }).catch ((err) => {
          this.loading_submit = false
          console.log(err.response.data.message)
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    }

  }
}
</script>

<style scoped>
.error {
  font-weight: bold;
  color: red;
}
</style>